import store from "./index"

const STORE_MODULES = [
  "auth", 
  "pages",
]

export default () => {
  STORE_MODULES.forEach((sm) => {
    store.commit(sm + "/clear")
  })
}